import React from 'react';

type BaseProps = {
  disabled?: boolean;
  icon: string;
  id: string;
};

type TextInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'disabled' | 'hidden'
>;

type Props = BaseProps & TextInputProps;

function AppFileInputButton({disabled = false, icon, id, ...rest}: Props) {
  return (
    <div
      className={`relative w-[56px] h-[32px] rounded-[100px]
        ${disabled && 'opacity-40 bg-white'}`}>
      <input type="file" id={id} disabled={disabled} hidden {...rest} />
      <label
        htmlFor={id}
        className="absolute inset-0 rounded-[100px] border-[1px] border-gray flex justify-center items-center cursor-pointer">
        <div className="w-[20px] h-[18px]">
          <img src={icon} alt="icon" className="w-full h-full object-contain" />
        </div>
      </label>
    </div>
  );
}

export default AppFileInputButton;
